import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type DiferencaProposta = { difere: boolean; numero_item?: string; numero_proposta?: string };

export async function consultarItemDifereDaProposta(itemId: string): Promise<DiferencaProposta> {
  const rpc = supabase.rpc.bind(supabase) as unknown as (fn: string, args: Record<string, unknown>) =>
    PromiseLike<{ data: DiferencaProposta | null; error: { message?: string } | null }>;
  const { data, error } = await rpc('fn_item_difere_da_proposta', { p_item_id: itemId });
  if (error) throw new Error(error.message || 'Não foi possível comparar o item com a proposta');
  return data ?? { difere: false };
}

export function useItemDifereDaProposta(itemId: string | null | undefined) {
  return useQuery({
    queryKey: ['item-difere-proposta', itemId],
    enabled: !!itemId,
    staleTime: 15_000,
    queryFn: () => consultarItemDifereDaProposta(itemId as string),
  });
}
